<template>
  <div class="category-selector">
    <v-layout row wrap v-on:click="selectCategories()">
      <v-flex xs10>
        <v-subheader>{{ getCategories.list.parent.name }}</v-subheader>
      </v-flex>
      <v-flex xs2>
        <v-subheader>
          <v-flex class="text-xs-right">
            <span v-if="categories.selecting === false" class="icon">
              <v-icon large>expand_more</v-icon>
            </span>
            <span v-else class="icon">
              <v-icon large>expand_less</v-icon>
            </span>
          </v-flex>
        </v-subheader>
      </v-flex>
      <v-flex xs12 v-if="categories.selecting === true" class="category-selector-childs container pb-0">
        <p v-if="getCategories.id !== getCategories.list.parent.id"
          v-on:click="choseCategories(getCategories.list.parent.parent_id)">
            <v-icon color="white" large>chevron_left</v-icon>&nbsp;
            {{ $t('Back') }}
        </p>
        <p v-for="item in getCategories.list.childs" v-bind:key="item.id" v-on:click="choseCategories(item.id)">
          {{ item.name }}
        </p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CategoriesSelector',
  data () {
    return {
      categories: {
        selecting: false
      }
    }
  },
  computed: {
    ...mapGetters([
      'getCategories'
    ])
  },
  methods: {
    ...mapActions([
      'setCategories',
      'setProductLists',
      'setSearchStatus'
    ]),
    ...mapMutations([
      'setKeywordSearch'
    ]),
    selectCategories () {
      if (this.categories.selecting === true) {
        this.categories.selecting = false
      } else {
        this.categories.selecting = true
      }
    },
    choseCategories (value) {
      var str = '?_page=1&_limit=12&_sort=id&_order=desc&type=categoryPage'
      var param = {'categoryId': value, 'queryString': str, 'loadMore': false}
      this.setProductLists(param).then(results => {
        this.setCategories(value)
        this.setKeywordSearch('')
        this.setSearchStatus(false)
      })
    }
  },
  created () {
    this.setCategories(this.getCategories.currentId).then(results => {
      var str = '?_page=1&_limit=12&_sort=id&_order=desc&type=categoryPage'
      var param = {'categoryId': this.getCategories.currentId, 'queryString': str, 'loadMore': false}
      this.setProductLists(param)
    })
  }
}
</script>

<style lang="scss" scoped>
.category-selector {
  background-color: #ccc;
  position: relative;
  height: 48px;

  .category-selector-childs {
    background-color: rgba(0, 0, 0, 0.8);
    color: #ffffff;
    position: absolute;
    top: 48px;
    z-index: 1;
    max-height: 240px;
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shopCategory/productsList/CategoriesSelector.vue